import { render, staticRenderFns } from "./NewsItems.vue?vue&type=template&id=5c72767e&scoped=true&"
import script from "./NewsItems.vue?vue&type=script&lang=js&"
export * from "./NewsItems.vue?vue&type=script&lang=js&"
import style0 from "./NewsItems.vue?vue&type=style&index=0&id=5c72767e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72767e",
  null
  
)

export default component.exports